import React from "react";
import "./src/styles/global.css";
import "./src/styles.scss";
import { I18nextProvider } from "react-i18next";
import { createI18nInstance } from "./src/utils/createI18nInstance";

export const wrapPageElement = ({ element, props }) => {
  const lang = props.pageContext.lang || props.pageContext.language || 'en';
  const translations = props.pageContext.translations;

  let i18n;
  if (translations) {
    i18n = createI18nInstance(lang, translations);
  } else {
    // Fallback for 404 or pages without translations in pageContext
    const i18next = require('i18next');
    i18n = i18next.createInstance();
    i18n.init({
      resources: {},
      lng: 'en',
      fallbackLng: 'en',
      interpolation: { escapeValue: false },
      initImmediate: false,
    });
  }

  return <I18nextProvider i18n={i18n}>{element}</I18nextProvider>;
};

// Order attribution (A2): remember how this session entered the site, so the
// buy button can pass landing page / referrer / utm to the Shopify checkout as
// cart attributes. Session-scoped, first-party, no identifiers, no cookies.
export const onClientEntry = () => {
  try {
    if (window.sessionStorage.getItem("vd_entry")) return;
    const u = new URL(window.location.href);
    window.sessionStorage.setItem(
      "vd_entry",
      JSON.stringify({
        l: (u.pathname + u.search).slice(0, 500),
        r: (document.referrer || "").slice(0, 300),
        t: new Date().toISOString(),
      })
    );
  } catch (e) {
    /* storage unavailable: attribution falls back to the current page */
  }
};
